import { Injectable } from '@angular/core';

function getWindow (): any {
    return window;
}

@Injectable({
  providedIn: 'root',
})
export class WindowServiceService {
  get nativeWindow (): any {
    return getWindow();
  }
  get location() {
    return window.location;
  }

  get isLocal(): boolean {
    return this.location["domain"] === "localhost";
  }

  redirectTo(url: string): void {
    this.location.href = url;
  }
}
